import {
    Component, Mixins, Watch,
} from 'vue-property-decorator';
import isEmpty from 'lodash.isempty';
import FormsMixin from '@components/shared/mixins/forms/index';
import Classes from '@components/shared/mixins/classes';
import config from '@components/shared/config';
import Props from './props';

/**
 * @name Radio
 */
@Component({})
class YRadio extends Mixins(Props, Classes, FormsMixin) {
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['color', 'size'];

    /**
     * The css parent class of the component
     */
    parentClass: string = this.componentClass(this.baseClass, config.prefix.radio);

    /**
     * Create Common Props for the radio.
     * 
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> {
        const commonProps: Record<string, any> = {
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            if (this.element && this.element[item]) {
                commonProps[item] = this.element[item];
            } else {
                commonProps[item] = this[item];
            }
        });
        return commonProps;
    }

    /**
     * Create classes array for the radio.
     * 
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Radio', this.commonProps, this.baseClass || config.prefix.radio));
        if (this.getBoolean('disabled')) {
            cls.push('is-disabled');
        }
        return cls;
    }

    /**
     * Inline Class
     * 
     * @returns {string}
     */
    get inlineClass(): string {
        return this.getBoolean('inline') ? `${this.parentClass}__inline` : '';
    }

    /**
     * Port Options to Groot 1
     * TODO: Remove this computed data after refactoring all radio components
     *
     * @deprecated
     * @returns {object}
     */
    get radioOptions(): { [key: string]: any } {
        const prop = this.getValue('options');
        let options = [];
        if (!isEmpty(prop)) {
            if (this.port) {
                Object.keys(prop).forEach((key) => {
                    options.push({
                        disabled: false,
                        readonly: false,
                        value   : Number(key),
                        label   : prop[key],
                        hint    : null,
                    });
                });
            } else {
                options = this.getValue('options');
            }
        }
        return options;
    }

    /**
     * Watch for options changes
     *
     * @param {Array} val
     */
    @Watch('options', { immediate: true, deep: true })
    onOptionsChanged(val: Array<{[k: string]: string|boolean}>): void {
        if (val && val.length && !this.model) {
            val.forEach((item) => {
                if (item.checked) {
                    this.model = item.value;
                }
            });
        }
    }

    /**
     * Assign value to the model
     * 
     * @param {any} val
     */
    @Watch('model')
    onModelReceived(val: any): any {
        this.model = val;
    }

    /**
     * Clear the selected
     */
    clear(): void {
        this.model = null;
    }
}

export default YRadio;
